<template>
  <div class="homeStyle">
    <Tabbar @toMore="showQrcode" :title="title" :enlishTitle="enlishTitle"></Tabbar>
    <div class="searchCard">
      <TableCard
        :tableList="dataList"
        @moreChange="patentToDetails"
      ></TableCard>
    </div>
    <CodeModel v-if="isShowCode"
               @cancel="codeCancel"></CodeModel>
  </div>
</template>

<script>
import Tabbar from './Tabbar.vue'
import TableCard from '@/components/common/tableCard'
import { picList } from '../../IndustryInformation/configs/config'
import { getIndustryInfo } from '@/api/IpProject'
import CodeModel from './codeModel'

export default {
  data() {
    return {
      picList,
      title: '专利信息分析',
      enlishTitle: 'PATENT INFORMATION ANALYSIS',
      dataList: [],
      isShowCode: false,
    }
  },
  mounted() {
    this.requestPatentList()
  },
  components: {
    Tabbar,
    TableCard,
    CodeModel,
  },
  methods: {
    showQrcode() {
      this.isShowCode = true
    },
    codeCancel() {
      this.isShowCode = false
    },
    patentToDetails(item) {
      this.$router.push({
        path: `/IndustryInformation/IndustryInformationList?id=${item.id}&name=${item.name}`,
      })
    },
    // 请求专利信息
    async requestPatentList() {
      let id = process.env.VUE_APP_OFFICE_ID
      let params = {
        pageNum: 1,
        pageSize: 2,
        id: id,
      }
      let res = await getIndustryInfo(params)
      this.loading = false
      this.isEmpty = res.total === 0
      this.dataList = res.data.reduce((pre, item, index) => {
        item = {
          ...item,
          img: this.picList[index],
        }
        pre.push(item)
        return pre
      }, [])
    },
  },
}
</script>